import styled from '@emotion/styled';
import { FC } from 'react';

import { OneTimePassFormData, OtpStatus } from '@/contexts/forms/OneTimePass';
import { OtpAddress } from '@/lib/apollo/types/gen/graphql';
import { OneTimePassConfirmProps } from '@/pages/Mypage/OneTimePass/Issue';
import { oneTimePassFormDataSessionStorage } from '@/storages/oneTimePass/formData';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

interface ArgOneTimePassConfirmProps {
  Component: FC<OneTimePassConfirmProps>;
}

const TopSpace = styled.div(() =>
  mq({
    paddingTop: [
      defaultTheme.spacing.m,
      defaultTheme.spacing.m,
      defaultTheme.spacing.xxl,
      defaultTheme.spacing.xxl,
    ],
  }),
);

const VerifyRoute: FC<ArgOneTimePassConfirmProps> = ({ Component }) => {
  const formData = oneTimePassFormDataSessionStorage.get();
  if (formData != null) {
    if (formData.moveTop) {
      return (
        <>
          <TopSpace></TopSpace>
          <Component oneTimePassFormData={formData} />
        </>
      );
    } else {
      return <Component oneTimePassFormData={formData} />;
    }
  }

  // ストレージにフォームデータを保存
  const tempForm: OneTimePassFormData = {
    otpAddress: OtpAddress.Sms,
    otpPurpose: 'signup-verify',
    otpResult: OtpStatus.InProgress,
    backUrl: '/signup/conversion',
    pageTitle: '利用登録',
    buttonName: '認証する',
    moveTop: true,
  };
  oneTimePassFormDataSessionStorage.set(tempForm);
  return <Component oneTimePassFormData={tempForm} />;
};

export default VerifyRoute;
